/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    CCSideBySide,
    ProductSingleCreditCards,
    ProductTableCreditCardScenario,
    SimpleCreditCardProductTable,
    TabbedProductTableCreditCardScenario,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [CCSideBySide.blockKey]: { render: CCSideBySide },
    [ProductSingleCreditCards.blockKey]: { render: ProductSingleCreditCards },
    [ProductTableCreditCardScenario.blockKey]: { render: ProductTableCreditCardScenario },
    [SimpleCreditCardProductTable.blockKey]: { render: SimpleCreditCardProductTable },
    [TabbedProductTableCreditCardScenario.blockKey]: { render: TabbedProductTableCreditCardScenario },
};

export default BLOCK_TO_COMPONENT_MAP;
